<template>
  <windowSocket class="socket-box" ref="socketRef" @message="onMessage" @open="onConnected">
    <div class="workvision-data-box">
      <div v-if="dataList.length === 0" class="data-item-box data-item-box--empty">
        <div class="empty-text">{{ langMap.workVisionNoRobotData[lang] }}</div>
      </div>
      <grid ref="gridRef" :colHeight="colHeight" :maxColumns="2" :showScreenBtnStatus="false">
        <template slot-scope="slot">
          <div class="data-item-box">
            <dataItem :robot="slot.data" :robotNum="dataList.length"/>
          </div>
        </template>
      </grid>
    </div>
  </windowSocket>
</template>
<script>
import windowSocket from '_c/windowSocket/index.vue';
import grid from '_c/grid/index.vue';
import dataItem from './subunits/dataItem.vue';
import api from "@/api";
import {checkAndFetchMenuList } from '@/libs/util';
import langMap from '@/utils/language';
import { mapState } from 'vuex';
let gridRef = null;
let lastIds = null;
let isFill = false;

const copy = (arr)=> JSON.parse(JSON.stringify(arr));
// 合并新旧机器人
function mergeRobots(arr, ids,language) {
  const copyArr = copy(arr);
  const _ids = copyArr.map(v => v.id);
  const newList = [];
  // 新增
  ids.forEach(id => {
    let _ix = _ids.indexOf(id);
    if (_ix >= 0) {
      // 已存在的机器人使用之前的数据
      newList.push(copyArr[_ix]);
    } else {
      // 新的机器人使用初始化
      newList.push({ id: id, ...getInitData(language) });
    }
  });
  return newList;
}

function prodRobotArray(arr, d = {}) {
  const _ids = arr || [];
  const data = _ids.map(v => {

    return { id: v, ...d };
  });
  return data;
}

function getIndexById(arr,id) {
  let _ix = -1;
  arr.some((v, i) => {
    if (v.id === id) { _ix = i; return true; }
  });
  return _ix;
}

/*TODO:调试时将数组置空（属性名需要保留）*/
function getInitData(language){
  return {
    version: { }, // 'c': { name: '电池版本', value: '30.39' }, 't': { name: 'cpu版本', value: '30.39' }
    warn: [], // { type: '提示', msg: '围栏故障' }
    status: { },
    move: [],//{ var1: '2343', var2: '00.00', direction: 22, speed: 20, acceleration: 9, gpsdatetime: 76 }
    handle: null,
    time: {},
    isOffline: true,
    tipContent: langMap.robotIsOffline[language],
    infoType:''
  };
}

export default {
  components: { windowSocket, grid, dataItem },
  data() {
    return {
      langMap:langMap,
      messageType: '',
      showBtn: true,
      dataList: []
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    colHeight(){
      return `${window.innerHeight - 70}px`;
    }
  },
  methods: {
    getRobots() {
      return api.getData("notice-server/usr/robot/list", this).then(res => {
        if (res.state === 1) {

          this.dataList = prodRobotArray(res.data, getInitData(this.lang));
          gridRef && gridRef.refreshList(this.dataList);
        }
      });
    },
    onMessage(data) {
      let _dataList = copy(this.dataList);
      const _id = data.robotId;
      let _ix = getIndexById(_dataList, _id);

      this.messageType = data.type;

      switch (data.type) {
        case 'robot_ids':
          const _idarr = data.data || []
          _dataList = mergeRobots(_dataList, _idarr,this.lang);
          break;
        case 'status:':
          _dataList[_ix].status = data.data;
          let _d = _dataList[_ix];
          _dataList.splice(_ix, 1, _d);
          break;
        case 'version:':
          _dataList[_ix].version = data.data;
          _dataList.splice(_ix, 1, _dataList[_ix]);
          break;
        case 'movement:':
          // 最大只保留200条
          var _len = _dataList[_ix].move.length;
          if (_len > 200) _dataList[_ix].move = _dataList[_ix].move.splice(_len - 200);
          _dataList[_ix].move.push(data.data);
          break;
        case 'notice:':
          var _len = _dataList[_ix].move.length;
          if (_len > 200) _dataList[_ix].move = _dataList[_ix].move.splice(_len - 200);
          _dataList[_ix].warn.push(data.data);
          break;
        case 'sentiment:':
          _dataList[_ix].time = data.data;
          _dataList[_ix].handle = null;
          _dataList.splice(_ix, 1, _dataList[_ix]);
          break;
        case 'sentiment_handle':
          _dataList[_ix].handle = data.data;
          _dataList.splice(_ix, 1, _dataList[_ix]);
          break;
        case 'offline:':
          // 重置此机器人数据
          let _robotItem = { ..._dataList[_ix],...getInitData(this.lang) };
          _robotItem.isOffline = true;
          _robotItem.tipContent = langMap.robotIsOffline[this.lang],
          _dataList.splice(_ix, 1, _robotItem);
          this.$nextTick(() => gridRef.showTip(_ix,'offline'));
          break;
        case 'online:':
          let _item = { ..._dataList[_ix], ...getInitData(this.lang) };
          _item.isOffline = false;
          _item.tipContent = langMap.robotIsOnline[this.lang],
          _dataList.splice(_ix, 1, _item);
          this.$nextTick(() => gridRef.showTip(_ix,'online'));
          break;
        default:
          console.warn('未知的类型--', data);
      }
      if(_ix>=0) _dataList[_ix].infoType = data.type;
      this.dataList = _dataList;

      // 刷新列表
      this.$nextTick(() => { gridRef && gridRef.refreshList(this.dataList); });
    },
    onConnected() {
      const userStore = this.$store.state.user.userInfo;
      this.$refs.socketRef.send({ type: 'online', robotId:'',data:`${userStore.userId}_data`,language: this.lang});
    }
  },
  updated() {
    gridRef = this.$refs.gridRef;
  },
  async mounted() {
    gridRef = this.$refs.gridRef;
    await this.getRobots();
    this.$refs.socketRef.init();
    checkAndFetchMenuList(this.$store);
    /* 测试使用
    setTimeout(() => {
      this.onMessage({
        type: 'online:', robotId: 1, data: { type: '提示', msg: '围栏故障' }
      });
    },2000);

    var qq = setInterval(() => {
      this.onMessage({
        type: 'online:', robotId: 1, data: { type: '提示', msg: '围栏故障' }
      });
      this.onMessage({
        type: 'online:', robotId: 4, data: { type: '提示', msg: '围栏故障' }
      });
      this.onMessage({
        type: 'status:',
        robotId: 1,
        data: [
          { name: 'name1', value: 'unknown' },
          { name: 'name2', value: undefined },
          { name: 'name3', value: null },
          { name: 'name4', value: 32432 }
        ]
      });
      this.onMessage({
        type: 'movement:', robotId: 1, data: { var1: '2343', var2: '00.00', direction: 22, speed: 20, acceleration: 9, gpsdatetime: 76 }
      })
    }, 3000);

    setTimeout(() => {
      window.clearInterval(qq);
      this.onMessage({
        type: 'offline:', robotId: 1, data: { type: '提示', msg: '围栏故障' }
      });
      this.onMessage({
        type: 'offline:', robotId: 4, data: { type: '提示', msg: '围栏故障' }
      });
    }, 9000);*/
  }
}
</script>
<style lang="less" scoped>
.data-item-box {
  min-height: 300px;
  box-sizing: border-box;
  background-color: black;
  height: 100%;
  width: 99%;
  padding: 6px;
  border-radius: 5px;

  /deep/.ivu-card-body {
    height: 100%;
  }

}
.data-item-box--empty{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.88);
  z-index: 2;
  .empty-text{
    padding: 18px 24px;
    border-radius: 8px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.12);
    color: rgba(255,255,255,0.85);
    font-size: 14px;
    letter-spacing: 0.5px;
  }
}
.workvision-data-box{
  height: 100%;
  position: relative;
}
</style>
